import { Injectable } from '@angular/core';
import { StudySearchStrategy } from '@models/searchStrategy.model';
import { Study } from '@models/study.model';
import { StudyService } from '@services/study.service';
import { StudyAnalysisService } from './study-analysis.service';
import { StudyDetailService } from './study-detail.service';

import { SearchFilterService } from '../mystudies/add-filter-dialog/shared/search-filter.service';

@Injectable({
  providedIn: 'root',
})
export class SearchStrategyService {
  public studySearchStrategy: StudySearchStrategy;

  constructor(
    private studyService: StudyService,
    private studyDetailService: StudyDetailService,
    private studyAnalysisService: StudyAnalysisService,
    private searchFilterService: SearchFilterService
  ) {
    this.studySearchStrategy = studyDetailService.study?.searchStrategies.find((s) => s.isActive === true);
    if (!this.studySearchStrategy) {
      this.studySearchStrategy = new StudySearchStrategy();
      studyDetailService.study.searchStrategies = [this.studySearchStrategy];
    }
  }

  public async addUpdateSearchStrategy(): Promise<Study> {
    const updateStudy = new Study();
    updateStudy.studyId = this.studyDetailService.study.studyId;
    updateStudy.isStudyDatabaseLocked = this.studyDetailService.study.isStudyDatabaseLocked;
    updateStudy.searchStrategies = this.studyDetailService.study.searchStrategies;

    const updatedStudy = await this.studyService.addUpdateSearchStrategy(updateStudy);
    const searchStrategy = updatedStudy.searchStrategies.find((s) => s.isActive);

    this.searchFilterService.generateFilterCriteriaForSearchFilters(searchStrategy.searchFilters);
    this.studyDetailService.study.searchStrategies[0] = searchStrategy;
    this.studySearchStrategy = searchStrategy;

    // update the header counts
    this.studyAnalysisService.updateStudyAnalysisCount(this.studySearchStrategy);

    return updatedStudy;
  }
}
